// @flow

import React from "react";
import { localize } from "redux-i18n";
import { compose } from "redux";
import { SectionComponent, Button } from "@components";
import { connect } from "react-redux";
import * as employeeSelectors from "@modules/employee/selectors";
import * as sharedSelectors from "@modules/shared/selectors";
import actionCreators from "@modules/employee/actionCreator";
import type { EmployeeType } from "@modules/employee/types";
import type { State } from "@store/reducers";
import { HierarchyScopeView } from "@modules/service/components/hierarchy-scope";
import type { HierarchyAssignment } from "@modules/service/types";
import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";
import type { UserAccount } from "@modules/employee/reducer/user-account-details/types";
import UserAccountAreaOfAccessEditModal from "../user-account-area-of-access-edit-modal";

type OwnProps = $Exact<{
  clientId: number,
  employeeId: number,
  employee: EmployeeType,
}>;

type PropsFromState = $Exact<{
  assignments: Array<HierarchyAssignment>,
  hierarchy: ?HierarchyTree,
  isEditModalVisible: boolean,
  userAccount: ?UserAccount,
}>;

type PropsFromDispatch = $Exact<{
  toggleEditModal: typeof actionCreators.ToggleUserAccountAssignmentsModal,
  updateUserAccount: typeof actionCreators.UpdateUserAccountAssignments,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

export class UserAccountAreaOfAccess extends React.Component<Props> {
  handleShowEditModal = () => {
    this.props.toggleEditModal(true);
  };

  handleCloseEditModal = () => {
    this.props.toggleEditModal(false);
  };

  handleSubmit = (assignments: Array<HierarchyAssignment>) => {
    this.props.updateUserAccount({
      clientId: this.props.clientId,
      employeeId: this.props.employeeId,
      data: {
        userType: this.props.userAccount && this.props.userAccount.userType,
        assignments,
      },
    });
  };

  render() {
    return (
      <SectionComponent
        title={<h5>{this.props.t("AREA_OF_ACCESS")}</h5>}
        rightLink={
          <Button materialIcon="edit" onClick={this.handleShowEditModal}>
            {this.props.t("EDIT")}
          </Button>
        }
      >
        {this.props.hierarchy && this.props.assignments ? (
          <HierarchyScopeView
            hierarchy={this.props.hierarchy}
            assignments={this.props.assignments}
          />
        ) : null}
        {this.props.isEditModalVisible && (
          <UserAccountAreaOfAccessEditModal
            assignments={this.props.assignments}
            hierarchy={this.props.hierarchy}
            onSubmit={this.handleSubmit}
            onDismissHandler={this.handleCloseEditModal}
          />
        )}
      </SectionComponent>
    );
  }
}

const mapStateToProps = (state: State): PropsFromState => ({
  hierarchy: sharedSelectors.getHierarchyTree(state),
  assignments: employeeSelectors.getUserAccountAssignments(state),
  isEditModalVisible: employeeSelectors.getIsEditAreaAccessModalVisible(state),
  userAccount: employeeSelectors.getUserAccount(state),
});

const mapDispatchToProps: PropsFromDispatch = {
  toggleEditModal: actionCreators.ToggleUserAccountAssignmentsModal,
  updateUserAccount: actionCreators.UpdateUserAccountAssignments,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(UserAccountAreaOfAccess);
